<template>
  <div id="page">
    <div>
      <van-nav-bar title="团长权转出" left-text="" left-arrow @click-left="onClickLeft()">
      </van-nav-bar>
      <div style="margin-top: 10px">
        <van-radio-group v-model="checked" @change="change">
          <van-radio :name="item.SDWorkerId" v-for="(item, idx) in list" v-bind:key="idx" style="margin-left:20px;padding-top:10px;">
            {{ item.SDWorkerName }}({{ item.SDWorkerTel }})
          </van-radio>
        </van-radio-group>
        <div style="margin: 16px">
          <van-button round block type="info" @click="TransferTeam">确认转出</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { NavBar, Button, Dialog, RadioGroup, Radio } from "vant";
export default {
  data() {
    return {
      teamId: 0,
      sdworkerId:0,
      list: [],
      checked:0,
    };
  },
  created() {
    this.teamId = this.$route.params.teamId;
    console.log(this.$route.params.teamId);
    this.QueryTeamDetail();
  },
  methods: {
    onClickLeft() {
      this.$router.back(-1);
    },
    change(e){
      this.sdworkerId=e;
    },
    QueryTeamDetail() {
      var that = this;
      that.$http
        .get("Team/QueryTeamDetail", {
          params: {
            teamId: that.teamId,
          },
        })
        .then((res) => {
          that.list = res.data.ListData;
        });
    },
    TransferTeam(){
      var that=this;
      if(that.sdworkerId == 0){
        return this.$toast.fail("请选择要转出的水工");
      }
      that.$http
        .get("Team/TransferTeam", {
          params: { sdworkerId: that.sdworkerId },
        })
        .then((res) => {
          if (res.data == "success") {
            that.$toast("团长权转出成功");
            that.$router.back(-1);
          } else {
            that.$toast(res.data);
          }
        });
    },
  },
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.name]: Dialog,
  },
};
</script>
<style scoped>
html {
  background: #f12416;
}
#page {
  width: 100%;
  height: 100%;
}
.indexPage {
  width: 100%;
  height: 100%;
  background-image: url("../assets/draw3/index.jpg");

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-content: space-around;
  justify-content: center;
  flex-wrap: wrap;
}
.mockTap {
  width: 280px;
  height: 280px;
  padding-top: 70px;
}
.step {
  z-index: 999;
}

.bounce-in-top {
  -webkit-animation: bounce-in-top 1.2s ease-in both;
  animation: bounce-in-top 1.2s ease-in both;
}
/* ----------------------------------------------
 * Generated by Animista on 2021-9-5 1:36:2
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation bounce-in-top
 * ----------------------------------------
 */
@-webkit-keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}
@keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}
</style>
